// refTracker — personal share-link tracking.
// Share links like tailorwiz.com/?r=john-smith. Every landing and every page
// the visitor opens afterward is logged (insert-only table), and the code is
// attached to Microsoft Clarity so the session replay can be filtered to
// exactly that person.
const ENDPOINT = "https://zjkzrobirkkrlmrfwshw.supabase.co/rest/v1/share_link_clicks";
const ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpqa3pyb2JpcmtrcmxtcmZ3c2h3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg4OTU5MDksImV4cCI6MjA5NDQ3MTkwOX0.Jy9Ks96_ikcc_pvauKg5C8WP532sI1QE4YVysybzHh0";
const SITE = "tailorwiz";
const KEY = "tw_share_ref";

function log(code: string, path: string, event: "landing" | "view") {
  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      apikey: ANON,
      Authorization: `Bearer ${ANON}`,
      "Content-Type": "application/json",
      Prefer: "return=minimal",
    },
    body: JSON.stringify({
      code,
      site: SITE,
      path: path.slice(0, 300),
      event,
      user_agent: navigator.userAgent.slice(0, 250),
      referrer: document.referrer.slice(0, 250),
    }),
  }).catch(() => { /* tracking must never break the app */ });
}

export function initRefTracker() {
  try {
    const params = new URLSearchParams(window.location.search);
    const incoming = (params.get("r") || params.get("ref") || "").trim().slice(0, 60);
    if (incoming) {
      localStorage.setItem(KEY, incoming);
      log(incoming, window.location.pathname, "landing");
    }
    const code = incoming || localStorage.getItem(KEY) || "";
    if (!code) return;

    // Tag the Clarity session so recordings are filterable by this code.
    const tagClarity = (): boolean => {
      const c = (window as unknown as { clarity?: (...a: unknown[]) => void }).clarity;
      if (typeof c === "function") { c("set", "ref", code); return true; }
      return false;
    };
    if (!tagClarity()) {
      let tries = 0;
      const iv = setInterval(() => { if (tagClarity() || ++tries > 20) clearInterval(iv); }, 500);
    }

    // Journey logging: record every SPA navigation while the code is active.
    let last = window.location.pathname;
    if (!incoming) log(code, last, "view"); // returning visit without the param
    const record = () => {
      if (window.location.pathname !== last) {
        last = window.location.pathname;
        log(code, last, "view");
      }
    };
    const origPush = history.pushState.bind(history);
    history.pushState = (...a: Parameters<typeof history.pushState>) => { origPush(...a); setTimeout(record, 0); };
    const origReplace = history.replaceState.bind(history);
    history.replaceState = (...a: Parameters<typeof history.replaceState>) => { origReplace(...a); setTimeout(record, 0); };
    window.addEventListener("popstate", () => setTimeout(record, 0));
  } catch { /* never break the app */ }
}
